module.exports = __webpack_public_path__ + "static/media/  (74).3e715b64.jpg";